/* pop-reveal — a fade + scale-up entrance for standalone decorative elements
   (GSAP), the single-element companion to card-reveal.js.

   When a [data-pop] element scrolls into view it fades in (autoAlpha 0 → 1) and
   scales up from 0.7 → 1. Any existing rotation is preserved — GSAP decomposes
   the element's current transform, so a tilted can keeps its tilt while it pops —
   and the element's CSS transform-origin is honoured so it grows from the same
   pivot (e.g. the cans rise from `bottom center`).

   Flash-free: [data-pop] elements are hidden from the first paint via CSS
   (`.js [data-pop]`); the script animates them in, or restores them when it
   bails. Inert under prefers-reduced-motion, the Shopify theme editor, or
   without GSAP / IntersectionObserver. Transform is NOT cleared on complete so
   the final rotation/scale stays put. */
(function () {
  const els = document.querySelectorAll('[data-pop]');
  if (!els.length) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const inEditor = window.Shopify && window.Shopify.designMode;
  const ready = window.gsap && 'IntersectionObserver' in window;

  if (reduceMotion || inEditor || !ready) {
    els.forEach((el) => { el.style.opacity = '1'; });
    return;
  }

  const gsap = window.gsap;

  els.forEach((el) => {
    // Honour the element's own transform-origin so scale composes with any
    // rotation around the same pivot the CSS uses (cans grow from bottom center).
    const origin = getComputedStyle(el).transformOrigin || 'center center';
    gsap.set(el, { autoAlpha: 0, scale: 0.7, transformOrigin: origin, willChange: 'transform, opacity' });

    const io = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      gsap.to(el, {
        autoAlpha: 1,
        scale: 1,
        duration: 1,
        ease: 'power3.out',
        // Drop the layer hint once settled (transform itself is kept — see below).
        onComplete: () => { el.style.willChange = 'auto'; },
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' });

    io.observe(el);
  });
})();
